import type { SegmentedChipOption } from '@pcln/horizon'

export const AI_SEARCH_MODE = 'ai'
export const STANDARD_SEARCH_MODE = 'standard'

const standardSearchModeOption: SegmentedChipOption = {
  label: 'Standard Search',
  value: STANDARD_SEARCH_MODE,
  name: 'search-mode',
  iconLeft: 'manage_search',
  type: 'chip',
}

const aiSearchModeOption: SegmentedChipOption = {
  label: 'Describe Your Trip',
  value: AI_SEARCH_MODE,
  name: 'search-mode',
  customIcon: 'AiSearch',
  type: 'chip',
  badge: { children: 'Beta', palette: 'penny', emphasis: 'medium', size: 'sm' },
}

export const SEARCH_MODE_OPTIONS: SegmentedChipOption[] = [standardSearchModeOption, aiSearchModeOption]

export const AI_SEARCH_PLACEHOLDER = 'Try ‘Orlando resort for a family of 4 in late July under $2000’'

export const AI_SEARCH_ANIMATED_PLACEHOLDERS = [
  'Los Angeles with Free Parking',
  'Nashville with Free Breakfast',
  'Las Vegas with Swimming Pool',
  'Phoenix with Pets Allowed',
] as const

export const AI_SEARCH_HELPER_TEXT = 'Tell us about your stay. Include a location for the best results.'

export const AI_SEARCH_INPUT_LABEL = 'Describe Your Trip'

export const AI_SEARCH_RECOMMENDATIONS_LABEL = 'Recommendations:'

export const AI_SEARCH_EXAMPLES_LABEL = 'Some examples to get you started:'

export const AI_SEARCH_LOADING_RECOMMENDATIONS = 'Loading recommendations'

export const AI_SEARCH_NO_RECOMMENDATIONS_BEFORE_LINK =
  'No recommendations yet. AI Search is in beta, for full results switch to '

export const AI_SEARCH_NO_RECOMMENDATIONS_LINK_LABEL = 'Standard Search'

export const AI_SEARCH_NO_RECOMMENDATIONS_AFTER_LINK = '.'

export const AI_SEARCH_RECOMMENDATIONS_ERROR = 'Recommendations are unavailable. Try again.'

export const AI_SEARCH_RESOLVE_ERROR_BEFORE_LINK =
  "We couldn't find a match for that trip. AI Search is in beta, for full results switch to "

/** Minimum trimmed characters before typeahead fetch / recommendation UI replaces example chips. */
export const AI_SEARCH_MIN_QUERY_LENGTH = 2

export function hasAiSearchMinLength(value: string) {
  return value.trim().length >= AI_SEARCH_MIN_QUERY_LENGTH
}

// Hardcoded for now. These will eventually be driven by type-ahead responses.
export const AI_SEARCH_TRY_ASKING_CHIPS = [
  'Las Vegas with Pool',
  'Miami Deals',
  'New York with Free Breakfast',
  'Chicago 4 Star+',
] as const
